import classNames from "classnames";
import { DietaryRestriction } from "../../../graphql/operations";
import ToolTip from "../../Atoms/ToolTip";
import s from "./DietarySummaryCard.module.scss";

type DietaryRowProps = {
  dietaryRestriction: DietaryRestriction;
};

export default function DietaryRow({
  dietaryRestriction: { diet, isPossible, memo },
}: DietaryRowProps) {
  const { isUnavailable, snippet } = isPossibleDetails[isPossible];

  return (
    <tr
      key={diet}
      className={classNames({
        [s["Unavailable"]]: isUnavailable,
      })}
    >
      <td>
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <p>{diet}</p>
          {memo && <ToolTip text={memo} />}
        </div>
      </td>

      <td>{snippet}</td>
    </tr>
  );
}

const isPossibleDetails = {
  yes: {
    isUnavailable: false,
    snippet: "✓ possible",
  },
  limited: {
    isUnavailable: false,
    snippet: "△ limited",
  },
  no: {
    isUnavailable: true,
    snippet: "✕ unavailable",
  },
} as const;
